var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}function ownKeys(e, r) {var t = Object.keys(e);if (Object.getOwnPropertySymbols) {var o = Object.getOwnPropertySymbols(e);r && (o = o.filter(function (r) {return Object.getOwnPropertyDescriptor(e, r).enumerable;})), t.push.apply(t, o);}return t;}function _objectSpread(e) {for (var r = 1; r < arguments.length; r++) {var t = null != arguments[r] ? arguments[r] : {};r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {_defineProperty(e, r, t[r]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));});}return e;}function _defineProperty(e, r, t) {return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;}function _toPropertyKey(t) {var i = _toPrimitive(t, "string");return "symbol" == typeof i ? i : i + "";}function _toPrimitive(t, r) {if ("object" != typeof t || !t) return t;var e = t[Symbol.toPrimitive];if (void 0 !== e) {var i = e.call(t, r || "default");if ("object" != typeof i) return i;throw new TypeError("@@toPrimitive must return a primitive value.");}return ("string" === r ? String : Number)(t);} /* eslint-disable react/no-multi-comp */
/* eslint-disable react-hooks/rules-of-hooks */
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router';
import { useAtom, useAtomValue } from 'jotai';
import { ChevronUpIcon, ChevronDownIcon } from '@heroicons/react/20/solid';

import { Translate, t } from "./..";
import { useOnClickOutsideElement } from "../../utils/useOnClickOutsideElementHook";
import { NeedAuthorization } from "../../V2/Components/UI";
import { inlineEditAtom, localeAtom, settingsAtom, userAtom } from "../../V2/atoms";

const locationSearch = (location) => {
  const cleanSearch = location.search.split(/page=\d+|&page=\d+/).join('');
  return cleanSearch === '?' ? '' : cleanSearch;
};

const prepareValues = (languages, locale, location) => {
  const selectedLanguage =
  languages.find((lang) => lang.key === locale) || languages.find((lang) => lang.default);

  const urlLocation = _objectSpread({}, location);

  const path = urlLocation.pathname.replace(new RegExp(`^/?${locale}/|^/?${locale}$`), '/');

  if (location.search.match(/page=/)) {
    urlLocation.search = locationSearch(location);
  }

  return { languages, selectedLanguage, urlLocation, path };
};

const SVGCircle = ({ fill }) => /*#__PURE__*/
_jsx("svg", { height: "20", width: "20", xmlns: "http://www.w3.org/2000/svg" }, void 0, /*#__PURE__*/
_jsx("circle", { r: "7", cx: "10", cy: "10", fill: fill })
);


// eslint-disable-next-line max-statements
const I18NMenu = () => {
  const [inlineEditState, setInlineEditState] = useAtom(inlineEditAtom);
  const locale = useAtomValue(localeAtom);
  const user = useAtomValue(userAtom);
  const { languages: languageList } = useAtomValue(settingsAtom);

  if (!languageList || languageList.length < 1 || languageList.length <= 1 && !(user !== null && user !== void 0 && user._id)) {
    return /*#__PURE__*/_jsx("div", { className: "no-i18nmenu" });
  }

  const location = useLocation();

  const menuRef = useRef(null);
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const { languages, selectedLanguage, path, urlLocation } = prepareValues(
    languageList,
    locale,
    location
  );

  useEffect(() => {
    if (locale !== (selectedLanguage === null || selectedLanguage === void 0 ? void 0 : selectedLanguage.key)) {
      window.location.assign(path);
    }
  }, [languages.length]);

  useOnClickOutsideElement(
    menuRef,
    useCallback(() => {
      setDropdownOpen(false);
    }, [])
  );

  return (/*#__PURE__*/
    React.createElement("li", {
      className: languageList.length === 1 ? 'menuNav-I18NMenu one-language' : 'menuNav-I18NMenu',
      "aria-label": "Languages",
      ref: menuRef },

    inlineEditState.inlineEdit && /*#__PURE__*/
    _jsx(NeedAuthorization, { roles: ['admin', 'editor'] }, void 0, /*#__PURE__*/
    _jsx("div", { className: "menuNav-language" }, void 0, /*#__PURE__*/
    _jsx("button", {
      className: "singleItem",
      type: "button",
      onClick: () =>
      setInlineEditState({ inlineEdit: false, translationKey: '', context: '' }),

      "aria-label": t('System', 'Turn off inline translation', null, false) }, void 0, /*#__PURE__*/

    _jsx("div", { className: "live-translate" }, void 0,
    inlineEditState.inlineEdit ? /*#__PURE__*/
    _jsx(SVGCircle, { fill: "#88eacd" }) : /*#__PURE__*/

    _jsx(SVGCircle, { fill: "#ffe66b" })

    )
    ), /*#__PURE__*/
    _jsx("span", { className: "singleItem" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Live translate")
    )
    )
    ),


    !inlineEditState.inlineEdit && /*#__PURE__*/
    _jsx("div", { className: "menuNav-language" }, void 0, /*#__PURE__*/
    _jsx("button", {
      className: "singleItem dropdown",
      type: "button",
      onClick: () => setDropdownOpen(!dropdownOpen) }, void 0, /*#__PURE__*/

    _jsx("span", {}, void 0, selectedLanguage === null || selectedLanguage === void 0 ? void 0 : selectedLanguage.localized_label), "\xA0",

    dropdownOpen ? /*#__PURE__*/_jsx(ChevronUpIcon, { width: 22 }) : /*#__PURE__*/_jsx(ChevronDownIcon, { width: 22 })
    ), /*#__PURE__*/

    _jsx("ul", { className: dropdownOpen ? 'dropdown-menu expanded' : 'dropdown-menu' }, void 0,
    languages.map((language) => {
      const url = `/${language.key}${path}${
      path.match('document') ? '' : urlLocation.search}`;


      return (/*#__PURE__*/
        _jsx("li", {

          className: locale === language.key ? 'menuNav-item active' : 'menuNav-item' }, language._id, /*#__PURE__*/

        _jsx("a", { href: url }, void 0, language.localized_label || language.label)
        ));

    }), /*#__PURE__*/

    _jsx(NeedAuthorization, { roles: ['admin'] }, void 0, /*#__PURE__*/
    _jsx("li", { className: "menuNav-item" }, void 0, /*#__PURE__*/
    _jsx("button", {
      className: "live-translate",
      type: "button",
      onClick: () => {
        setInlineEditState({
          inlineEdit: !inlineEditState.inlineEdit,
          translationKey: '',
          context: ''
        });
        setDropdownOpen(false);
      } }, void 0,

    inlineEditState.inlineEdit ? /*#__PURE__*/
    _jsx(SVGCircle, { fill: "#88eacd" }) : /*#__PURE__*/

    _jsx(SVGCircle, { fill: "#ffe66b" }), /*#__PURE__*/

    _jsx(Translate, {}, void 0, "Live translate")
    )
    )
    )
    )
    )

    ));

};

export { I18NMenu };